import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
// Hooks
import { useAuthContext } from "../../hooks/useAuthContext";
// Components
import LoginForm from "./components/LoginForm";

function Login() {
  // Get the currently authenticated user
  const { user } = useAuthContext();
  // Used to redirect authenticated users
  const navigate = useNavigate();

  useEffect(() => {
    if (user)
      // Redirect logged-in users away from the login page
      navigate("/projects", { replace: true });
  }, [user, navigate]);

  // Prevent the login page from briefly appearing before redirect
  if (user) return null;

  return <LoginForm />;
}

export default Login;
